import script from "./form-service.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-service.vue?vue&type=script&setup=true&lang=ts"

import "./form-service.vue?vue&type=style&index=0&id=646561d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-646561d6"]])

export default __exports__